import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Routes, Route, Navigate } from "react-router-dom";
import { routeConfigs } from "./config";
import { getToken } from "@/utils/auth"; // 导入获取Token的工具函数
// 受保护路由组件：验证Token，无Token则跳转到登录页
const ProtectedRoute = ({ children }) => {
    // 检查是否有Token
    const hasToken = !!getToken();
    // 没有Token且不在登录页 → 重定向到登录页（并携带当前路径作为redirect参数）
    if (!hasToken) {
        // 获取当前路径（从window.location.pathname获取）
        const currentPath = window.location.pathname;
        // 避免登录页自己重定向自己
        if (currentPath !== "/login") {
            return (_jsx(Navigate, { to: `/login?redirect=${encodeURIComponent(currentPath)}`, replace: true }));
        }
    }
    // 有Token或已在登录页 → 正常渲染
    return _jsx(_Fragment, { children: children });
};
// 获取左侧导航路由
export const getLeftNavRoutes = () => {
    return routeConfigs.slice(0, 3);
};
// 获取右侧导航路由
export const getRightNavRoutes = () => {
    return routeConfigs.slice(3, 6);
};
// 根据路径获取路由配置
export const getRouteByPath = (path) => {
    return routeConfigs.find((route) => route.path === path);
};
// 路由组件
export default function AppRoutes() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(ProtectedRoute, { children: _jsx(Navigate, { to: "/common", replace: true }) }) }), routeConfigs.map((route) => {
                const Component = route.element;
                // 登录页不需要保护，其他页面都需要验证Token
                const isPublicRoute = route.path === "/login";
                return (_jsx(Route, { path: route.path, element: isPublicRoute ? (_jsx(Component, {})) : (_jsx(ProtectedRoute, { children: _jsx(Component, {}) })) }, route.path));
            }), _jsx(Route, { path: "*", element: _jsx(ProtectedRoute, { children: _jsx(Navigate, { to: "/login", replace: true }) }) })] }));
}
